import Reactotron from 'reactotron-react-js';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

const reactotronConfig = (rootReducer, rootSaga) => {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    let sagaMiddleware = createSagaMiddleware();
    let store = null;

    if (process.env.NODE_ENV === 'development') {
        const sagaMonitor = Reactotron.createSagaMonitor();

        sagaMiddleware = createSagaMiddleware({ sagaMonitor });

        const middleWares = [sagaMiddleware];
        const middlewareEnhancer = applyMiddleware(...middleWares);

        const enhancers = [middlewareEnhancer, Reactotron.createEnhancer()];
        const composedEnhancers = composeEnhancers(...enhancers);

        store = createStore(rootReducer, composedEnhancers);
        sagaMiddleware.run(rootSaga);

        return store;
    }

    store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
    sagaMiddleware.run(rootSaga);

    return store;
};

export default reactotronConfig;
